<template>
    <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
            <v-btn
                v-on="{ ...tooltip }"
                :small="params.small ? true :false"
                :rounded="params.rounded ? true : false"
                :fab="params.fab ? true : false"
                :icon="params.icon ? true : false"
                :color="params.button_color ? params.button_color : ''"
                @click.native.stop="openDialog()">{{ params.text ? params.text : '' }}
                <v-icon v-if="params.icon_name" :color="params ? params.color : ''">{{ params.icon_name }}</v-icon>

                <v-dialog v-model="show" max-width="900" persistent class="round-card" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" scrollable>
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">{{ titleDialog }} Evento</p>
                            <v-spacer></v-spacer>
					        <v-btn icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
                        </v-card-title>            
                        <v-divider></v-divider>
                        <v-card-text class="px-1 pb-1">

                            <v-container v-if="show" fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6 mx-0">
                                <fields-generator
                                    :fieldsset.sync="fieldsset"
                                    :model="event"
                                    ref="fieldsgenerator"
                                ></fields-generator>
                                <small class="px-4">* Indica i campi obbligatori</small>
                            </v-container>
                            <v-divider></v-divider>

                        </v-card-text> 

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                            </v-btn>
                            <v-btn text color="primary" @click.native.stop="createModel()" :loading="loading">{{params.create ? 'Crea Nuovo' : 'Modifica'}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-btn>
        </template>
        <span>{{ titleDialog }} Evento</span>
    </v-tooltip>
</template>

<script>

    import Vue from 'vue'
    import FormsMixin from '@/mixins/FormsMixin'


    export default {
        name: 'event-button-dialog',
        mixins: [FormsMixin],
        props: {
            model: Object,
            params: Object,
        },

        data() {
            return {
                support: {},
                show: false,
                fieldsset: {},
                loading: false,
                event: {},
                fullScreen: false,
                confirmExit: false,
            }
        },

        computed: {
            titleDialog() {
                return this.params.create ? 'Creazione' : 'Modifica'
            }
        },

        watch: {
            event: {
                handler() {
                    // setTimeout(0) per andare DOPO il microtask di revalidate di vee-validate,
                    // che altrimenti wiperebbe l'errore custom appena aggiunto.
                    setTimeout(() => this.validateTimeRange(), 0)
                },
                deep: true,
            },
        },

        methods: {

            // Validazione cross-field manuale su "Ora Fine" (vee-validate v2 non risolve
            // @start_time perché i field sono indicizzati per label, non per key).
            // Ritorna true se l'intervallo è valido o non valutabile, false altrimenti.
            validateTimeRange() {
                const fg = this.$refs.fieldsgenerator
                if (!fg || !fg.$validator) return true
                const validator = fg.$validator
                // Rimuovo SOLO il nostro errore custom (per non wipare la rule is_time gestita da vee-validate)
                validator.errors.items
                    .filter(e => e.field === 'Ora Fine' && e.rule === 'time_range')
                    .forEach(e => validator.errors.removeById(e.id))
                if (this.event.allday) return true
                const startedAt = this.event.started_at
                const endedAt = this.event.ended_at
                const startTime = this.event.start_time
                const endTime = this.event.end_time
                if (!startedAt || !endedAt || !startTime || !endTime) return true
                const startMs = moment(startedAt + ' ' + startTime, 'YYYY-MM-DD H:mm').valueOf()
                const endMs = moment(endedAt + ' ' + endTime, 'YYYY-MM-DD H:mm').valueOf()
                if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return true
                if (endMs <= startMs) {
                    validator.errors.add({
                        field: 'Ora Fine',
                        msg: 'L\'orario di fine deve essere successivo all\'orario di inizio',
                        rule: 'time_range',
                    })
                    return false
                }
                return true
            },


            closeDialog() {
                this.show = false
            },

            openDialog() {
                const requests = [this.axios.get('events/create')]
                if (this.params.create) {
                    requests.push(this.axios.get('profile-calendar-settings'))
                }

                Promise.all(requests).then(responses => {
                    const createResp = responses[0]
                    const settingsResp = responses[1]
                    this.fieldsset = createResp.data.fields

                    if (this.params.create) {
                        // Applica i default raw dal template_data (anche se false/0/'' vanno propagati
                        // per rendere reattive le rispettive chiavi — es. allday usato da depends_key)
                        _.forEach(this.fieldsset.fields, (value) => {
                            if (value.default !== undefined && value.key) {
                                Vue.set(this.event, value.key, value.default)
                            }
                        })

                        // Calcola start_time arrotondato alla mezz'ora superiore e
                        // end_time = start + durata configurata per-utente (fallback 60).
                        const rawDuration = settingsResp && settingsResp.data && settingsResp.data.settings
                            ? settingsResp.data.settings.event_default_duration_minutes
                            : null
                        const durationMinutes = Number.isFinite(Number(rawDuration)) && Number(rawDuration) >= 5
                            ? Number(rawDuration)
                            : 60
                        const m = moment()
                        const ceil30 = Math.ceil(m.minute() / 30) * 30
                        const startMoment = m.clone().minute(0).second(0).millisecond(0).add(ceil30, 'minutes')
                        const endMoment = startMoment.clone().add(durationMinutes, 'minutes')
                        Vue.set(this.event, 'start_time', startMoment.format('HH:mm'))
                        Vue.set(this.event, 'end_time', endMoment.format('HH:mm'))

                        this.show = true
                    } else {
                        this.axios.get('events/' + this.model.id + '/edit').then(response => {
                            // Riassegna l'oggetto (invece di Object.assign mutante) così Vue 2
                            // re-osserva tutte le proprietà → reactive, incluso `allday` su cui dipende il depends.
                            this.event = { ...response.data.model }
                            Vue.set(this.event, 'start_time', moment(this.event.started_at).format('HH:mm'))
                            Vue.set(this.event, 'started_at', moment(this.event.started_at).format('YYYY-MM-DD'))
                            Vue.set(this.event, 'end_time', moment(this.event.ended_at).format('HH:mm'))
                            Vue.set(this.event, 'ended_at', moment(this.event.ended_at).format('YYYY-MM-DD'))
                            this.show = true
                        })
                    }
                })
            },

            // Derive started_at / ended_at timestamps (ms) from the form fields
            // without mutating this.event, so a retry after a 4xx response still
            // sees the original "YYYY-MM-DD" + "HH:mm" inputs (not a previously
            // computed ms value that would re-parse to "Invalid date").
            buildEventPayload() {
                let startedAtMs
                let endedAtMs
                if (this.event.allday) {
                    startedAtMs = moment(this.event.started_at).startOf('day').format('x')
                    endedAtMs = moment(this.event.ended_at).endOf('day').format('x')
                } else {
                    startedAtMs = moment(this.event.started_at + ' ' + this.event.start_time, 'YYYY-MM-DD H:mm').format('x')
                    endedAtMs = moment(this.event.ended_at + ' ' + this.event.end_time, 'YYYY-MM-DD H:mm').format('x')
                }
                return {
                    ...this.event,
                    started_at: startedAtMs,
                    ended_at: endedAtMs,
                }
            },

            //model is trouble
            createModel() {
                this.confirmExit = false

                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    // Chiamato DOPO validateAll perché altrimenti l'errore custom su "Ora Fine"
                    // verrebbe wipato dal validator stesso.
                    const timeRangeOk = this.validateTimeRange()
                    if (!result || !timeRangeOk) {
                        return this.handleValidationErrorAdvanced()
                    }

                    const payload = this.buildEventPayload()

                    if (!Number.isFinite(Number(payload.started_at)) || !Number.isFinite(Number(payload.ended_at))) {
                        // Safety net per orari non parsabili (è già coperto dalle rules vee-validate)
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: 'Data o orario non valido',
                            value: true,
                            color: 'error',
                        })
                        return
                    }

                    if (this.params.create) {
                        this.axios.post('events', payload).then(response => {
                            this.event = {}
                            this.$store.commit('setModelEdited', false)
                            this.$eventBusUtility.$emit('refreshCalendar')
                            this.show = false
                        }, response => {

                        })
                    } else {
                        this.axios.put('events/' + this.event.id, payload).then(response => {
                            this.$store.commit('setModelEdited', false)
                            this.$eventBusUtility.$emit('refreshCalendar')
                            this.show = false
                            this.event = {}
                        }, response => {

                        })
                    }
                }).catch(() => {

                })
            },
        },
    }
</script>